import React from 'react';
import { observer } from 'mobx-react';
import { observable, action, computed } from 'mobx';
import _ from 'lodash';
import Text from './common/Text';
import CircleLoader from '../components/Loader/CircleLoader';

@observer
class Stepper extends React.Component {
  @observable currentStep = 0;
  @observable intervalId = null;

  componentDidMount() {
    this.setupAutoCheck();
  }
  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  @action.bound
  next() {
    const { steps, onComplete } = this.props;
    this.currentStep += 1;
    if (this.currentStep >= steps.length) {
      onComplete();
      return;
    }

    this.setupAutoCheck();

    return this.intervalId;
  }

  async setupAutoCheck() {
    const { steps } = this.props;
    const currStep = steps[this.currentStep];
    if (!currStep) return;
    const autocheck = currStep.autocheck;
    if (autocheck) {
      const res = await this.checkCondition();
      if (res) return;

      //Else setup interval to check again
      const interval = steps[this.currentStep].interval;
      this.intervalId = setInterval(this.checkCondition, interval);
    } else if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  @computed
  get stepCount() {
    return this.props.hasIntroStep
      ? this.props.steps.length - 1
      : this.props.steps.length;
  }

  @computed
  get interval() {}

  checkCondition = async () => {
    const { steps } = this.props;
    const currStep = steps[this.currentStep];
    if (!currStep) return;
    const autocheck = currStep.autocheck;
    const res = await autocheck();
    if (res) {
      this.next();
    }
    return res;
  };

  getBG(stepNum) {
    const { hasIntroStep } = this.props;
    const isSameOrBefore = hasIntroStep
      ? stepNum <= this.currentStep - 1
      : stepNum <= this.currentStep;
    return isSameOrBefore ? 'bg-coolGray' : '';
  }

  render() {
    const { hasIntroStep, steps, onComplete } = this.props;
    const inner = steps[this.currentStep];
    if (!inner) {
      return (
        <div className="f f-cc f-1">
          <CircleLoader show={true} />
        </div>
      );
    }
    return (
      <div className="f f-center-center f-1 f-rows">
        {!hasIntroStep ||
          (this.currentStep > 0 && (
            <div className="f f-columns">
              {_.times(this.stepCount, stepNum => (
                <div
                  key={stepNum}
                  className={`h-16 w-16 brad-mx b-1 b-coolGray ${this.getBG(
                    stepNum,
                  )} ${stepNum === 0 ? '' : 'ml-l'}`}
                />
              ))}
            </div>
          ))}

        {inner.render(this.next)}
        {!inner.required && (
          <div>
            <Text mt={4} onClick={this.next} link clickable className="b-0 bb-1 b-primaryDark">
              I'll do this later
            </Text>
          </div>
        )}
      </div>
    );
  }
}

export default Stepper;



// WEBPACK FOOTER //
// ./src/components_new/Stepper.js